<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
    &copy; {{year}}, Bitwarden Inc & Raytio Ltd.
    <br> {{'versionNumber' | i18n : version}}
</div>
